import { Text, View, Touchable } from '@/components'
import { analytics } from '@/services'
import { Post } from '@/types'
import React from 'react'
import { Learn } from '@/features'

type LessonReferenceProps = {
  lesson: Post['lesson']
  variantColor?: string
}

export function LessonReference(props: LessonReferenceProps) {
  const { lesson, variantColor } = props

  const handleLessonPress = () => {
    analytics.track('lesson_view', { lesson_name: lesson?.title })
    Learn.tryOpenLesson(lesson?.id, null, 'feed')
    return
  }

  if (!lesson) return null
  return (
    <View variants={['gap:0.4']}>
      <Text variants={['p5', 'row', variantColor as any]}>
        Find out more in
      </Text>
      <Touchable debugName="feed lesson press" onPress={handleLessonPress}>
        <Text variants={['p5', 'bold', variantColor as any]}>
          {lesson?.title}
        </Text>
      </Touchable>
    </View>
  )
}
